// Consent Banner Component
// GDPR/CCPA compliant consent banner for error logging

import React, { useState, useEffect } from 'react';
import consentManager from '../utils/consentManager';
import './ConsentBanner.css';

function ConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Check if banner should be shown
    if (!consentManager.hasConsent() && consentManager.shouldShowBanner()) {
      // Small delay to ensure page is loaded
      const timer = setTimeout(() => {
        setIsVisible(true);
        setIsAnimating(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    consentManager.grantConsent();
    consentManager.dismissBanner();
    setIsAnimating(false);
    setTimeout(() => setIsVisible(false), 300);
    // Reload page to activate logging with consent
    window.location.reload();
  };

  const handleDecline = () => {
    consentManager.dismissBanner();
    setIsAnimating(false);
    setTimeout(() => setIsVisible(false), 300);
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`consent-banner ${isAnimating ? 'consent-banner-visible' : ''}`}
      role="dialog"
      aria-labelledby="consent-banner-title"
      aria-describedby="consent-banner-description"
    >
      <div className="consent-banner-content">
        <div className="consent-banner-text">
          <h3 id="consent-banner-title" className="consent-banner-title">
            Privacy & Error Logging
          </h3>
          <p id="consent-banner-description" className="consent-banner-description">
            We use error logging to improve our website. This collects technical information 
            (errors, browser type, screen size) but no personal data. Your consent helps us 
            fix bugs faster.
          </p>
        </div>
        <div className="consent-banner-actions">
          <button
            className="consent-banner-button consent-banner-accept"
            onClick={handleAccept}
            aria-label="Accept error logging"
          >
            Accept
          </button>
          <button
            className="consent-banner-button consent-banner-decline"
            onClick={handleDecline}
            aria-label="Decline error logging"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConsentBanner;

